import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiHttpService } from '../../services/apihttp.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor(private spinner : NgxSpinnerService, private http : ApiHttpService) { }

  ngOnInit(): void {
    this.http.loaderState.subscribe(data=>{
      this.spinner.show();
      if(data)
      this.spinner.show();
      else
      this.spinner.hide();
    });
  }
}
